var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.doShowElectronicScrollInner
        ? _c("electronic-scroll", { attrs: { content: _vm.content } })
        : _vm._e(),
      _c("dialog-wakeUp", {
        attrs: { content: _vm.content, dialogVisible: _vm.showDialogInner },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "dialog-dialog",
          attrs: {
            title: "系統通知",
            visible: _vm.innerDialogVisible,
            "append-to-body": "",
            "close-on-click-modal": false,
            "destroy-on-close": true,
            "show-close": false,
            width: _vm.device == "mobile" ? "90%" : "60%",
          },
          on: {
            closed: function ($event) {
              _vm.innerDialogVisible = false
            },
            "update:visible": function ($event) {
              _vm.innerDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("el-alert", {
                staticStyle: {
                  "background-color": "#ffd643",
                  color: "#4b4b4b",
                },
                attrs: {
                  title: _vm.customerComplaintContent,
                  type: "info",
                  effect: "dark",
                  "show-icon": "",
                  closable: false,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.innerDialogVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.webAiUrl && !_vm.isMobile && !_vm.isMinimized
        ? _c("div", { staticClass: "floating-window" }, [
            _c(
              "button",
              {
                staticClass: "close-btn",
                on: { click: _vm.minimizeFloatingWindow },
              },
              [_vm._v("×")]
            ),
            _c("img", {
              attrs: {
                src: require("@/assets/images/WebAI.png"),
                alt: "Web AI",
              },
              on: { click: _vm.openWebAiUrl },
            }),
          ])
        : _vm._e(),
      _vm.webAiUrl && !_vm.isMobile && _vm.isMinimized
        ? _c(
            "div",
            {
              staticClass: "floating-circle",
              on: { click: _vm.restoreFloatingWindow },
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/images/AICircle.png"),
                  alt: "Web AI Minimized",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.isFullScreen
        ? _c("div", { staticClass: "full-screen-overlay" }, [
            _c(
              "button",
              {
                staticClass: "close-fullscreen-btn",
                on: { click: _vm.closeFullScreen },
              },
              [_vm._v("×")]
            ),
            _vm.webAiUrl
              ? _c("iframe", {
                  staticClass: "full-screen-iframe",
                  attrs: {
                    src: _vm.webAiUrlWithAgency,
                    frameborder: "0",
                    allow: "microphone",
                  },
                })
              : _vm._e(),
          ])
        : _vm._e(),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "Web AI",
            visible: _vm.drawerVisible,
            size: "50%",
            "with-header": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerVisible = $event
            },
          },
        },
        [
          _vm.webAiUrl
            ? _c("iframe", {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  src: _vm.webAiUrlWithAgency,
                  frameborder: "0",
                  allow: "microphone",
                },
              })
            : _vm._e(),
        ]
      ),
      _vm.isMobile
        ? _c("footer", { staticClass: "mobile-footer" }, [
            _vm.webAiUrl
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/images/WebAIMobile.png"),
                    alt: "Web AI Mobile",
                  },
                  on: { click: _vm.openWebAiUrl },
                })
              : _vm._e(),
          ])
        : _vm._e(),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }